var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52083 2.375V6.33333H11.4792V2.375H7.52083ZM6.72917 0C5.85472 0 5.14583 0.708883 5.14583 1.58333V7.125C5.14583 7.99945 5.85472 8.70833 6.72917 8.70833H12.2708C13.1453 8.70833 13.8542 7.99945 13.8542 7.125V1.58333C13.8542 0.708883 13.1453 0 12.2708 0H6.72917ZM2.375 12.6667V16.625H6.33333V12.6667H2.375ZM1.58333 10.2917C0.708883 10.2917 0 11.0005 0 11.875V17.4167C0 18.2911 0.708883 19 1.58333 19H7.125C7.99945 19 8.70833 18.2911 8.70833 17.4167V11.875C8.70833 11.0005 7.99945 10.2917 7.125 10.2917H1.58333ZM12.6667 16.625V12.6667H16.625V16.625H12.6667ZM10.2917 11.875C10.2917 11.0005 11.0005 10.2917 11.875 10.2917H17.4167C18.2911 10.2917 19 11.0005 19 11.875V17.4167C19 18.2911 18.2911 19 17.4167 19H11.875C11.0005 19 10.2917 18.2911 10.2917 17.4167V11.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson);
export default __webpack_public_path__ + "static/media/Lesson.7dfb5de8011ad35bd00527409f39e179.svg";
export { ForwardRef as ReactComponent };